import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { retry, timeout, catchError, map} from 'rxjs/operators';
import { throwError } from 'rxjs'
import { Router } from '@angular/router';
import { UtilsService } from './utils.service';
import { SocialService } from './social.service';
import { ErrorHandlerService } from './error-handler.service';
import { environment } from '../../environments/environment';
import { SuccessResponse, ErrorResponse } from '../interfases/responses.interfases';

@Injectable({
	providedIn: 'root'
})


export class LoginService {

	constructor(
		private http:HttpClient,
		private router:Router,
		private socialService:SocialService,
		private errorHandler:ErrorHandlerService,
		) {
		this.APIKEY = environment.API_KEY;
		this.APIURL = environment.API_URL;
		this.TEMPOCONSULTA = environment.TEMPOCONSULTA;
	}

	accesos:any;
	status:string = null;


	APIKEY:string;
	APIURL:string;
	TEMPOCONSULTA:number;
	token:string = "";
	identificador:string = ""; 

	temporizador:any;

	public async cargarIdDispositivo() {
		this.identificador = await localStorage.getItem('idp') || null;
		return this.identificador;
	}

	private async guardarToken(token:string){
		this.token = token;
		await localStorage.setItem('pf-token', token);
	}

	public async cargarToken() {
		this.token = await localStorage.getItem('pf-token') || null;
		return this.token;
	}


	async login(usuario:string, pass:string){
		const URL:string = this.APIURL + 'usuarios/login';
		await this.cargarIdDispositivo();
		const headers = new HttpHeaders({
			'Ls-Apikey': this.APIKEY,
			'Ls-Id': this.identificador,
		});
		let body = new HttpParams();
			body = body.append('usuario', usuario);
			body = body.append('contrasena', pass);
		
		return new Promise( async (resolve, reject) => {
			this.http.post(URL, body, { headers}).subscribe( async (res:any) => {
				if(!res.error){
					await this.guardarToken(res.token);
					resolve(true);
				}else{
					reject(res.msg);
				}
			}, async (err:any) => {
				const error = typeof err === 'object' && err !== null ? err.message : err || 'Error desconocido';
				console.error(error);
				/*if(error.error){
					if(error.error.respuesta){
						if(error.error.respuesta.msg === 'INVALID_APIKEY'){
							await localStorage.removeItem('idp');
							reject(error.error.respuesta.msg);
						}else{
							reject(error.error.respuesta.msg);
						}
					}else{
						reject(error.error.msg);
					}
				*/
				if (error === 'INVALID_APIKEY') {
					await localStorage.removeItem('idp');
					reject(error);
				}else{
					reject(error);
				}
			})
		})
		
		/*
		return this.http.post(URL, body, { headers }).pipe(
			retry(1), // Solo intenta una vez más
			catchError((error: any) => {
				console.error('Error en login:', error);
				return throwError(new Error(error?.message || 'Error desconocido'));
			})
		).toPromise();
		*/
		/*
		return new Promise(async (resolve, reject) => {
			this.http.post(URL, body, { headers }).pipe(
				retry(1), // Reintenta la petición una vez en caso de error
				catchError((error: any) => {
					console.error('Error en login1:', error);

					const errorMsg = error?.error?.respuesta?.msg || error?.error?.msg || 'Error desconocido';

					// Manejo especial para APIKEY inválida
					if (errorMsg === 'INVALID_APIKEY') {
						localStorage.removeItem('idp');
					}
					return throwError(new Error(error?.message || 'Error desconocido'));
				})
			).toPromise()
			.then(async (res: any) => {
				if (!res.error) {
					await this.guardarToken(res.token);
					resolve(true);
				} else {
					reject(res.msg);
				}
			})
			.catch(error => {
				const errorMsg = typeof error === 'object' && error !== null ? error.message : error || 'Error desconocido';
				console.error('Error en login:', errorMsg); //Genera error aqui

				if (errorMsg === 'INVALID_APIKEY') {
					localStorage.removeItem('idp');
				}
				reject(errorMsg || 'Error desconocido');
			});
		});
		*/
	}

	public async logout(){
		await localStorage.removeItem('pf-token');
		this.token = null;
		this.status = null;
		this.socialService.logout();
		this.router.navigateByUrl('/login');
	}



	async postSocialLogin(token):Promise<any>{
		await this.cargarIdDispositivo();
		const url:string = `${this.APIURL}usuarios/loginsocial/${token}`;

		const headers = new HttpHeaders({
			'Ls-Apikey': this.APIKEY,
			'Ls-Id': this.identificador,
		});

		let body = new HttpParams;

		return new Promise( (resolve, reject) => {
			this.http.post(url, body, { headers } ).subscribe( async (res:SuccessResponse) => {
				await this.guardarToken(res.data.token);
				resolve(res.data);
			},(err:any) => {
				console.error(err);
				let error:ErrorResponse = err.error;
				this.errorHandler.validateErrorResponse(error);
				reject(err);
			})
		})
	}

	async postCrearSocialLogin(token):Promise<any>{
		await this.cargarIdDispositivo();
		const url:string = `${this.APIURL}usuarios/createsocial/${token}`;
		const headers = new HttpHeaders({
			'Ls-Apikey': this.APIKEY,
			'Ls-Id': this.identificador,
		});
		let body = new HttpParams;
		return new Promise( (resolve, reject) => {
			this.http.post(url, body, { headers } ).subscribe( async (res:SuccessResponse) => {
				await this.guardarToken(res.data.token);
				resolve(res.data);
			},(err:any) => {
				console.error(err);
				let error:ErrorResponse = err.error;
				this.errorHandler.validateErrorResponse(error);
				reject(err);
			})
		})
	}

	/*================================================
	=            VALIDAR QUE TOKEN ACTIVO            =
	================================================*/
	public async validarUsuarioEstado(): Promise<boolean> {
		await this.cargarToken();
		await this.cargarIdDispositivo();

		if ( !this.token ) {
			this.router.navigateByUrl('/login');
			return Promise.resolve(false);
	    }

		return new Promise<boolean>(resolve => {
			if(this.token.length > 10){
				resolve(true);
			}else{
				resolve(false);
			}
		})


		return;


		if ( !this.token ) {
			this.router.navigateByUrl('/login');
			return Promise.resolve(false);
		}

		if ( !this.identificador ) {
			this.logout();
			return Promise.resolve(false);
		}

		return new Promise<boolean>( resolve =>{
			let URL = this.APIURL + '/usuarios/validacion';
			const headers = new HttpHeaders({
				'Ls-Apikey': this.APIKEY,
				'Ls-Id': this.identificador,
				'Authorization': `Bearer ${this.token}`,
			});

			this.http.get(URL, {headers}).subscribe( async (res:any) => {
				// this.accesos = res.acceso;
				if(!res.error){
					resolve(true);
				}else{
					await this.logout();
					this.router.navigateByUrl('/login');
					resolve(false);
				}

			}, async (err:any) =>{
				await this.logout();
				this.router.navigateByUrl('/login');
				resolve(false);
			})
		})
	}

	public async validarVistaLogin(): Promise<boolean>{
		return new Promise ( async resolve => {
			await this.cargarToken();
			await this.cargarIdDispositivo();
			if ( !this.token  || !this.identificador ) {
				resolve(true);
			}else{
				this.router.navigateByUrl('/main');
				resolve(false);
			}
		})
	}










	/*====================================
	=            CREAR CUENTA            =
	====================================*/
	async crearCuenta(data){
		const URL:string = this.APIURL + 'usuarios/crearcuenta';
		await this.cargarIdDispositivo();

		const headers = new HttpHeaders({
			'Ls-Apikey': this.APIKEY,
			'Ls-Id': this.identificador
		});

		let body = new HttpParams();
			body = data;

		return new Promise ( (resolve, reject) => {
			this.http.post(URL, body, { headers }).subscribe( async (res:any) => {
				resolve(res);
			}, (err:any)=>{
				console.error(err);
				reject(err);
			})
		})
	}

	async logoutPerfil() {
		await this.cargarToken();
		await this.cargarIdDispositivo();



		const URL:string = this.APIURL + 'aficionados/logout';

		const headers = new HttpHeaders({
			'Ls-Apikey': this.APIKEY,
			'Ls-Id': this.identificador,
			'Authorization': `Bearer ${this.token}`
		});

		let body = new HttpParams();

		this.token = null;

		return new Promise ( (resolve, reject) => {
			this.http.post(URL, body, { headers }).subscribe( async (res:any) => {
				resolve(res);
			}, (err:any)=>{
				reject(err);
			})
		})
	}

	

	async guardarStorage( key:string, value:string ) {
	 	// await this.storage.set(key, value);
	}
	async leerStorage_token() {
		// this.token = await this.storage.get('acuser-token') || null;
		return this.token;
	}




	








	public async validarAutenticacion(): Promise<boolean>{
		await this.leerStorage_token();

		if ( !this.token ) {
			return Promise.resolve(false);
	    }

		return new Promise<boolean>(resolve => {
			if(this.token.length >= 10){
				resolve(true);
			}else{
				resolve(false);
			}
		})
	}



	public async validarAutenticacion_login(): Promise<boolean>{
		await this.leerStorage_token();

		if ( this.token ) {
			// this.navCtrl.navigateRoot('/tabs/tab3/perfil');
			return Promise.resolve(false);
	    }else{
	    	return Promise.resolve(true);
	    }
	}





	/*============================================
	=            RECUPERAR CONTRASEÑA            =
	============================================*/
	//recuperarcontrasena
	async recuperarContrasena(data:any){
		const URL:string = this.APIURL + 'usuarios/recuperarcontrasena';
		await this.cargarIdDispositivo();

		const headers = new HttpHeaders({
			'Ls-Apikey': this.APIKEY,
			'Ls-Id': this.identificador,
		});


		let body = new HttpParams;
			body = data;

		return new Promise( (resolve, reject) => {
			this.http.post(URL, body, { headers } ).subscribe( (res:any) => {
				resolve(res);
			},(err:any) => {
				console.error(err)
				reject(err);
			})
		})
	}

	async reenviarValidacion(data:any){
		const URL:string = this.APIURL + 'usuarios/reactivacion';
		await this.cargarIdDispositivo();

		const headers = new HttpHeaders({
			'Ls-Apikey': this.APIKEY,
			'Ls-Id': this.identificador,
		});


		let body = new HttpParams;
			body = data;

		return new Promise( (resolve, reject) => {
			this.http.post(URL, body, { headers } ).subscribe( (res:any) => {
				resolve(res);
			},(err:any) => {
				console.error(err)
				reject(err);
			})
		})
	}
	
	






}

